import { Pagination } from 'is24-corecss';
import React, { BaseSyntheticEvent } from 'react';

import Table from '../table/Table';
import { TeamMember } from '../../../../models/TeamMember';

type TeamMembersTableProps = {
  currentPageNr: number;
  pageSize: number;
  teamMembers: Array<TeamMember>;
  onPageChange: (page: number) => void;
  totalPages: number;
  onMemberDeletion: (teamMember: TeamMember) => void;
  onMemberUpdate: (teamMember: TeamMember) => void;
  onInvite: (teamMember: TeamMember) => void;
  onRevokeInvitation: (teamMember: TeamMember) => void;
  onSort: (column: string) => void;
  sortOrder: string;
  sortColumn: string;
  onCopyInvitationLink: (teamMember: TeamMember) => void;
};

const TeamMembersTable: React.FC<TeamMembersTableProps> = ({
  onPageChange,
  currentPageNr,
  pageSize,
  totalPages,
  teamMembers,
  onMemberDeletion,
  onMemberUpdate,
  onInvite,
  onRevokeInvitation,
  onSort,
  sortOrder,
  sortColumn,
  onCopyInvitationLink,
}: TeamMembersTableProps) => {
  const handlePaginationChange = (event: BaseSyntheticEvent) => {
    const pageNr = event.currentTarget.getAttribute('page') - 1;
    history.pushState({ page: pageNr }, '');
    onPageChange(pageNr);
  };

  return (
    <div data-testid='team-members-management-table' className='padding-bottom-l'>
      <Table
        rows={teamMembers}
        onDeleteRow={onMemberDeletion}
        onEditRow={onMemberUpdate}
        onInvite={onInvite}
        onRevokeInvitation={onRevokeInvitation}
        onSort={onSort}
        sortOrder={sortOrder}
        sortColumn={sortColumn}
        currentPageNr={currentPageNr}
        pageSize={pageSize}
        onCopyInvitationLink={onCopyInvitationLink}
      />
      <div data-testid='members-pagination' className='grid-flex grid-justify-center margin-top-m'>
        <Pagination
          pages={totalPages}
          activePage={currentPageNr + 1}
          onClickPage={handlePaginationChange}
          onClickNext={handlePaginationChange}
          onClickPrev={handlePaginationChange}
        />
      </div>
    </div>
  );
};

export default TeamMembersTable;
